import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

import { IStudyGroupMember } from '../study_group_interfaces';

export class StudyGroupMembersBuilder implements IStudyGroupMember, IIndexable {
  id: number;
  name: string = '';
  email: string = '';
  selected_pronouns: string = '';
  formatted_pronouns: string = '';
  _isChecked: boolean = false;
  constructor(source: IStudyGroupMember) {
    return _4.merge(this, { _isChecked: false }, source);
  }
  static build(source: IStudyGroupMember) {
    return new StudyGroupMembersBuilder(source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/builders/study_group_members_builder.ts